module.exports = __webpack_public_path__ + "static/media/gsc.506a9b83.svg";